import { useState } from 'react';

export function CodeBlock({ code, maxHeight = 320 }: { code: string; maxHeight?: number }) {
  const [copied, setCopied] = useState(false);
  const [full, setFull] = useState(false);
  const copy = () => {
    void navigator.clipboard.writeText(code);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1200);
  };
  return (
    <div
      style={{
        position: 'relative',
        background: 'var(--bg-2)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--r-lg)',
      }}
    >
      <button
        onClick={copy}
        className="t-caption"
        style={{
          position: 'absolute',
          top: 8,
          right: 10,
          border: 'none',
          background: 'none',
          color: 'var(--accent)',
          cursor: 'pointer',
        }}
      >
        {copied ? 'Copiato' : 'Copia'}
      </button>
      <pre
        style={{
          margin: 0,
          padding: '12px 14px',
          paddingRight: 64,
          tabSize: 2,
          font: '400 12px/18px var(--font-mono)',
          color: 'var(--dim)',
          overflowX: 'auto',
          maxHeight: full ? undefined : maxHeight,
          overflowY: 'auto',
        }}
      >
        {code}
      </pre>
      {!full && code.split('\n').length > 16 && (
        <button
          onClick={() => setFull(true)}
          className="t-caption"
          style={{
            display: 'block',
            width: '100%',
            border: 'none',
            borderTop: '1px solid var(--border)',
            background: 'none',
            color: 'var(--accent)',
            cursor: 'pointer',
            padding: 6,
          }}
        >
          Mostra tutto
        </button>
      )}
    </div>
  );
}
